"use strict";

class UnitIndexController {

    constructor($scope, $window, $filter, Upload, SSHttpService, SSConfigService, SSAlertService, SSUtilService, OTPService, SSAppService, NgTableParams, SSAwsService, SSUserService, SSAnalyticsService, SSConfirmationService, SettingsService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.filter = $filter;

        self.Upload = Upload;
        self.NgTableParams = NgTableParams;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;
        self.SSAnalyticsService= SSAnalyticsService;
        self.SSConfirmationService = SSConfirmationService;
        self.SettingsService = SettingsService;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.UNITS_POPULATED = false;

        // Units Import
        self.importParams = {};
        self.unitsDataFileProcessed = false;
        self.unitsImageFilesProcessed = false;
        self.unitAssets = {};
        // Units Import

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        self.select_status = [];
        self.search_types = [];
        self.search_categories = [];
        self.search_price_types = [];
        self.search_floorPlan = [];
        self.selectedAgency = [];
        self.filtered_units = [];

        self.reverseSort = false;

        self.unit_status = 0;

        self.offset = 0;
        self.limit = 10;
        self.selected_units_count = 0;

        self.current = 1;
        self.jump_to_page = 1;
        self.getGSTSettings();
        self.pageChanged = function(newPage) {
            if (self.sortColumn) {
                self.sortData(self.sortColumn, true);
            } else {
                self.loadUnits(newPage);
            }
        };

        self.setPageOptions();

        self.unitStatuses = [];
        self.unitStatusesFilter = [];
        self.edited_fields= [];
        self.editableStatus = [
            self.UNIT_STATUS_DRAFT,
            self.UNIT_STATUS_LISTED,
            self.UNIT_STATUS_SOLD,
            self.UNIT_STATUS_SPECIAL_RESERVED
        ];

        self.OPTIONS_MAP=[
            {"id": "1", "value": "Reserve Price"},
            {"id": "2", "value":  "Category"},
            {"id": "3", "value":  "Type"},
            {"id": "4", "value":  "Name"},
            {"id": "5", "value": "Price"},
            {"id": "6", "value": "Status"},
            {"id": "7", "value": "Commission/Incentives"},
        ];

        self.PRICE_MAP=[
            {"id": "1", "value":  "Fixed Price"},
            {"id": "2", "value":  "Increase By Percentage"},
            {"id": "3", "value":  "Decrease By Percentage"},
            {"id": "4", "value":  "Increase By Price"},
            {"id": "5", "value": "Decrease By Price"},
        ];

        self.types = self.SSConfigService.serverConfig.unit_types;
        self.categories = self.SSConfigService.serverConfig.unit_categories;
        self.price_types = self.SSConfigService.serverConfig.unit_price_types;


        if (!self.data.property_id)
            return;

        let url = 'properties/' + self.data.property_id + '/floorplans';

        // let params = {
        //     'include_assets': 1
        // };

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.floorPlans = response.data.floorplans;

            jQuery.each(self.floorPlans, function (i, status) {
                self.search_floorPlan.push({id: status.name, title: status.name});
            });

        });

        jQuery.each(self.SSConfigService.serverConfig.unit_statuses, function (i, status) {
            if (self.editableStatus.indexOf(status.id) != -1) {
                self.unitStatuses.push(status);
                self.select_status.push({id:status.name, title:status.name});
            }
            self.unitStatusesFilter.push(status);
        });

        jQuery.each(self.types, function (i, status) {
            self.search_types.push({id:status.name, title:status.name});
        });

        jQuery.each(self.categories, function (i, status) {
            self.search_categories.push({id:status.name, title:status.name});
        });

        jQuery.each(self.price_types, function (i, status) {
            self.search_price_types.push({id:status.name, title:status.name});
        });


        self.modifyChanges = false;
        self.params = {
            property_id: self.data.property_id,
            status: self.unitStatuses[0]
        };

        self.param = {
            property_id: self.data.property_id
        };

        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };

        self.getUnits();

        // self.getFloorPlans();
        // watch for check all checkbox
        self.$scope.$watch(function () {
            return self.checkboxes.checked;
        }, function (value) {


            jQuery.each(self.units, function (i, item) {
                // if (self.isUnitEditable(item)) {
                self.checkboxes.items[item.id] = value;
                // }
            });
        });


        self.SSAnalyticsService.drawTotalViewsByProjectChart;
        // self.getAllAgencies();
    }

    sortData(column, skip_reverse = false){
        const self = this;

        if (!skip_reverse){
            self.reverseSort = (self.sortColumn == column) ? !self.reverseSort : false;
        }
        self.sortColumn = column;

        let sortedUnits = [];

        let units = angular.copy(self.unitsBackup);
        if (self.isSearchApplied()) {
            units = self.getFilteredUnits();
        }

        // self.units_master will have single page data
        if(self.reverseSort){
            sortedUnits = _.sortBy(units, column).reverse();
        } else {
            sortedUnits = _.sortBy(units, column);
        }

        let page = self.current? self.current : undefined;
        self.loadUnits(page, sortedUnits);
    }

    getSortClass(column){
        const self = this;

        if(self.sortColumn == column){
            return self.reverseSort ? 'fa fa-caret-down' : 'fa fa-caret-up';
        }
    }

    applySearch(){
        const self = this;

        var units = self.unitsBackup;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        self.filtered_units = angular.copy(units);

        if (self.sortColumn) {
            self.sortData(self.sortColumn, true);
        } else {
            self.loadUnits(undefined, units);
        }
        // Re-Assign CheckAll filter
        //self.toggleCheckAll();
    }

    isSearchApplied(){
        const self = this;

        if(!self.block_name_search && !self.unit_no_search && !self.floor_search && !self.unit_search
            && !self.category_search && !self.floor_plan_type_search && !self.name_search && !self.price_type_search
            && !self.reserve_price_search && !self.price_search && !self.psf_search && !self.status_search){
            return false;
        }
        return true;
    }

    getFilteredUnits(){
        const self = this;

        let units = [];

        if (self.block_name_search) {
            units = self.unitsBackup.filter(x => x.stack_name.toLowerCase().indexOf(self.block_name_search.toLowerCase().trim()) > -1);
        } else {
            units = angular.copy(self.unitsBackup);
        }

        if (self.unit_no_search) {
            if (units.length > 0) {
                units = units.filter(x => {
                    let concatenated_named_id = x.named_id? '#' + x.named_id : '#';
                    return concatenated_named_id.indexOf(self.unit_no_search.trim()) > -1
                });
            } else {
                units = self.unitsBackup.filter(x => {
                    let concatenated_named_id = x.named_id? '#' + x.named_id : '#';
                    return concatenated_named_id.indexOf(self.unit_no_search.trim()) > -1
                });
            }
        }

        if (self.floor_search) {
            if (units.length > 0) {
                units = units.filter(x => x.floor_no.toString().indexOf(self.floor_search.trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.floor_no.toString().indexOf(self.floor_search.trim()) > -1);
            }
        }

        if (self.unit_search) {
            if (units.length > 0) {
                units = units.filter(x => x.unit_no.toString().indexOf(self.unit_search.trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.unit_no.toString().indexOf(self.unit_search.trim()) > -1);
            }
        }

        if (self.category_search) {
            if (units.length > 0) {
                units = units.filter(x => x.category == self.category_search);
            } else {
                units = self.unitsBackup.filter(x => x.category == self.category_search);
            }
        }

        if (self.floor_plan_type_search) {
            if (units.length > 0) {
                units = units.filter(x => x.floor_plan_id == self.floor_plan_type_search);
            } else {
                units = self.unitsBackup.filter(x => x.floor_plan_id == self.floor_plan_type_search);
            }
        }

        if (self.name_search) {
            if (units.length > 0) {
                units = units.filter(x => x.name.toLowerCase().indexOf(self.name_search.toLowerCase().trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.name.toLowerCase().indexOf(self.name_search.toLowerCase().trim()) > -1);
            }
        }

        if (self.price_type_search) {
            if (units.length > 0) {
                units = units.filter(x => x.price_type == self.price_type_search);
            } else {
                units = self.unitsBackup.filter(x => x.price_type == self.price_type_search);
            }
        }

        if (self.price_search) {
            if (units.length > 0) {
                units = units.filter(x => x.price.toString().indexOf(self.price_search.trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.price.toString().indexOf(self.price_search.trim()) > -1);
            }
        }

        if (self.reserve_price_search) {
            if (units.length > 0) {
                units = units.filter(x => x.reserve_price && x.reserve_price.toString().indexOf(self.reserve_price_search.trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.reserve_price && x.reserve_price.toString().indexOf(self.reserve_price_search.trim()) > -1);
            }
        }

        if (self.psf_search) {
            if (units.length > 0) {
                units = units.filter(x => x.psf.toString().indexOf(self.psf_search.trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.psf.toString().indexOf(self.psf_search.trim()) > -1);
            }
        }

        if (self.status_search) {
            if (units.length > 0) {
                units = units.filter(x => x.status == self.status_search);
            } else {
                units = self.unitsBackup.filter(x => x.status == self.status_search);
            }
        }


        // _.each(self.unitsBackup, function(unit){

        //     if(unit.block_no && self.block_no_search && unit.block_no.toString().includes(self.block_no_search)){
        //         units.push(unit);
        //     }
        //     if(unit.named_id && self.unit_no_search && unit.named_id.includes(self.unit_no_search)){
        //         units.push(unit);
        //     }
        //     if(unit.formatted_category && self.category_search && unit.formatted_category.trim().toLowerCase().includes(self.category_search.trim().toLowerCase())){
        //         units.push(unit);
        //     }
        //     if(unit.formatted_floor_plan_type && self.floor_plan_type_search && unit.formatted_floor_plan_type.trim().toLowerCase().includes(self.floor_plan_type_search.trim().toLowerCase())){
        //         units.push(unit);
        //     }
        //     if(unit.name && self.name_search && unit.name.trim().toLowerCase().includes(self.name_search.trim().toLowerCase())){
        //         units.push(unit);
        //     }
        //     if(unit.formatted_price_type && self.price_type_search && unit.formatted_price_type.trim().toLowerCase().includes(self.price_type_search.trim().toLowerCase())){
        //         units.push(unit);
        //     }
        //     if(unit.price && self.price_search && unit.price.toString().includes(self.price_search)){
        //         units.push(unit);
        //     }
        //     if(unit.psf && self.psf_search && unit.psf.toString().includes(self.psf_search)){
        //         units.push(unit);
        //     }
        //     if(unit.status && self.status_search && unit.status.toString().includes(self.status_search)){
        //         units.push(unit);
        //     }
        // });

        return units;
    }

    // Statuses: ALL, LISTED, DRAFT, BOOKED etc
    filterUnitsByStatus(status){
        const self = this;

        self.unit_status = status;

        //Reset all search/filter
        self.resetSearchFilter();

        let units = self.unitsBackup;

        if(self.isStatusFilterApplied()){
            units = self.getUnitsByStatus(self.unit_status);
        }

        self.filtered_units = angular.copy(units);

        // params: self.loadUnits(pageNum, filtered/sorted units);
        self.loadUnits(undefined, units);
        // Re-Assign CheckAll filter
        self.toggleCheckAll();
    }

    isStatusFilterApplied(){
        const self = this;

        if(self.unit_status){
            return true;
        }
        else{
            return false;
        }
    }

    getUnitsByStatus(status){
        const self = this;

        let units = [];

        jQuery.each(self.unitsBackup, function(index, unit){
            if(unit.status == status){
                units.push(unit);
            }
        });

        return units;
    }

    cancelChanges() {
        const self = this;

        loading(true);

        self.edited_status = '';
        self.editable = !self.editable;
        self.edited_fields = [];

        self.units_master = angular.copy(self.unitsBackup);

        if(self.param){
            self.param.category = null;
            self.param.type = null;
            self.param.name = null;
            self.param.pricetype = null;
            self.param.price = null;
        }


        // self.SSAlertService.danger('Oops!', 'Your changes cancelled');
        self.changesApplied = false;

        // Mark check all as false before cancelling the changes
        self.checkAll = false;
        self.toggleCheckAll();

        loading(false);
    }

    getAllAgencies() {
        const self = this;

        self.agency_list = null;
        self.projectAgency =null;

        let url = 'agencies';
        let params = {
            'format': 1
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.agency_list = response.data.agencies;
            self.getPropertyAgencies();
        });
    }

    getPropertyAgencies() {
        const self = this;
        self.agencyFormat = [];

        let url = 'sec/developer/agencies';

        let params = {
            property_id : self.param.property_id,
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.propery_agency_list = response.data.property_agencies;
            jQuery.each(self.propery_agency_list, function(i, agency){
                agency.name = self.agency_list.find(function (x) { return x.id == agency.agency_id; }).name;
                self.agencyFormat.push({id:agency.agency_id, label:agency.name});
            });
        });
    }

    showSelectedFields(field) {
        const self = this;

        self.editby=[];

        jQuery.each(self.OPTIONS_MAP, function (i, options){
            self.editby[options.value]=false;
        });
        if(field=="price"){
            self.price_show = true;
        }else {
            self.price_show = false;
        }
        self.editby[field]=true;

    }

    saveUnits(units){

        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self.save_units = [];
            self.save_units_data = [];
            self.mode_edited_units = [];

            self.edited_units = Array.from(new Set(self.edited_units));
            self.edited_status = null;

            if (!self.param.name
                && !self.param.price
                && !self.param.status
                && !self.param.category
                && !self.param.type
                && !self.selectedAgency.length > 0
            ) {
                self.mode_edited_units = self.units_master;
            } else {
                self.mode_edited_units = self.units;
            }

            jQuery.each(self.mode_edited_units, function(i, unit){

                if (jQuery.inArray(unit.id, self.edited_units) !== -1) {
                    self.save_units.push(unit);
                }
            });

            jQuery.each(self.save_units , function(i, unit){
                let units_data = {
                    "id":unit.id,
                    "floor_no":unit.floor_no,
                    "unit_no":unit.unit_no,
                    "type":unit.floorplan,
                    "category": unit.category,
                    "reserve_price": unit.reserve_price,
                    "price": unit.price,
                    "floorplan_id" : unit.floor_plan_id,
                    "price_type": unit.price_type,
                    "name":unit.name,
                    "status":unit.status,
                };
                self.save_units_data.push(units_data);
            });

            let importUrl = 'sec/developer/units/'+ self.property.id +'/json-update';
            let params = {
                propertyId: self.property.id,
                units_data: {"units": self.save_units_data},
            };

            loading(true);
            self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    if (response.code == 401) {
                        self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                    } else if (response.code == 412) {
                        self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                    } else {
                        self.SSAlertService.danger('Oops!', 'Please make changes and save');
                    }
                    return;
                }

                self.editable = !self.editable;

                jQuery.each(self.units, function(i, unit) {
                    self.checkboxes.items[unit.id] = false;
                    self.formatUnitData(unit);
                });

                self.edited_fields=[];
                self.units_master_converted = angular.copy(self.units);

                if(self.agencyIdSelected)
                {
                    if (self.agencyIdSelected.length > 0) {
                        self.addUnitsCommission();
                    }
                }

                self.SSAlertService.success('Success!', 'All data saved successfully.');
                self.checked = 0;
                self.checkAll = false;
                self.changesApplied = false;
                self.param = {};
                self.params.field = null;
                self.showSelectedFields(null);
                self.progressUploadingFiles = false;
                self.getUnits();
            });
        });
    }

    addUnitsCommission(){
        const self = this;

        let unit_ids = [];
        jQuery.each(self.units, function(i, unit){

            if (jQuery.inArray(unit.id, self.edited_units) !== -1) {
                unit_ids.push(unit.id);
            }
        });

        let url = 'sec/developer/units/' + self.property.id + '/bulk-update-commission-incentives';
        self.registerErrors =null;
        let params = {
            unit_ids: unit_ids.length>0 ? unit_ids.toString() : "",
            agency_ids: self.agencyIdSelected.length > 0 ? self.agencyIdSelected.toString() : "",
            agency_commission_value: self.param.agency_commission_value,
            agency_commission_type: self.param.agency_commission_type,
            agency_commission_gst_inclusive: self.param.agency_commission_gst_inclusive,
            broker_incentives_value: self.param.broker_incentives_value,
            broker_incentives_type: self.param.broker_incentives_type,
            broker_incentives_gst_inclusive: self.param.broker_incentives_gst_inclusive,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }

        });
    }

    getUnits() {
        const self = this;

        if (!self.property.id)
            return;

        self.stacks = [];
        self.units = [];
        self.units_master = [];
        self.edited_units = [];
        self.firstWatch = null;

        let url = 'sec/developer/properties/' + self.property.id + '/units';
        let params = {
            offset: 0,
            limit: 1500 // Consider max value
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.UNITS_POPULATED = true;
            self.stacks = response.data.stacks;

            let units = angular.copy(response.data.property_units);
            units = self.SSUtilService.getSortedUnits(units, false, 'named_id');

            self.units = units;

            jQuery.each(self.units, function (i, unit) {
                self.formatUnitData(unit);
            });

            self.unitsBackup = units;

            self.count = self.unitsBackup.length;

            jQuery.each(self.units, function (i, item) {
                self.$scope.$watchCollection(function () {
                    return self.units[i];
                }, function (newValue, oldValue) {

                    if ( self.firstWatch=="20" ) {
                        self.edited_units.push(newValue.id);
                    }
                });
            });

            self.units_master = angular.copy(self.units);
            self.units_master_converted = angular.copy(self.units);

            self.loadUnits(undefined, self.units_master);
        });
    }

    // CLIENT SIDE PAGINATION
    loadUnits(page, units){
        const self = this;

        // if(self.unit_status && !filtered){
        //     self.filterUnitsByStatus(self.unit_status);
        // }

        if(page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
            self.jump_to_page = page;
        }

        if(!units){
            units = angular.copy(self.unitsBackup);
            if (self.isSearchApplied()) {
                units = self.getFilteredUnits();
            }
        }

        self.units_master = units.slice(self.offset, self.limit + self.offset);
        self.count = units.length;

        // SET 'CURRENT SELECTED UNITS' COUNT
        if(parseInt(self.limit) < parseInt(self.units_master.length)){
            self.selected_units_count = self.limit;
        }
        else{
            self.selected_units_count = self.units_master.length;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.count / self.limit);
        self.setTotalPagesOptions(total_pages);
    }

    watch_enable(field, id, field_name) {
        const self = this;

        let dirty_id = id;


        if (jQuery.inArray(dirty_id, self.edited_fields) === -1) {
            self.edited_fields.push(dirty_id);
        }

        self.firstWatch = "20";
        self.edited_status = "Changes has been made. Do you want to save?";
    }

    CheckFields(id, field) {
        const self = this;
        let dirty_id = field+'_'+ id;

        if (jQuery.inArray(dirty_id, self.edited_fields) !== -1) {
            return true;
        }

        return false;
    }

    searchArray(array, id) {
        const self = this;

        if (!array || !id) return '';

        if (typeof array == "string") {
            array = self.serverConfig[array];
        }
        let object = null;
        jQuery.each(array, function(i, e) {
            if (e.id == id) {
                object = e;
            }
        });

        return object ? object.name : '';
    }

    formatUnitData(unit) {
        const self = this;

        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber1(unit);

        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_type = self.SSConfigService.getUnitTypeName(unit.type);
        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_status = self.SSConfigService.getUnitStatusName(unit.status);
        unit.formatted_price_type = self.SSConfigService.getUnitPriceTypeName(unit.price_type);
        unit.formatted_floor_plan_type = unit.floor_plan ? unit.floor_plan : '';
        unit.formatted_floor_plan_type = self.searchArray(self.floorPlans, unit.floor_plan_id);
        unit.actual_price = unit.price;

        let stack = self.findStack(unit.stack_id);
        if (stack) {
            unit.block_no = stack.block_no;
            unit.stack_name = stack.name;
        }

        // By default set the 'checked' status to false
        unit.checked = false;

        return unit;
    }

    findStack(stackId) {
        const self = this;

        let stack = null;

        jQuery.each(self.stacks, function (i, _stack) {
            if (stackId == _stack.id) {
                stack = _stack;
                return false;
            }
        });

        return stack;
    }

    viewUnit(unit) {
        const self = this;

        self.$window.location.href = '/developer/properties/' + self.property.named_id + '/units/' + unit.named_id;
    }

    isUnitEditable(unit) {
        const self = this;
        return unit.status == self.UNIT_STATUS_DRAFT || unit.status == self.UNIT_STATUS_LISTED || unit.status == self.UNIT_STATUS_SOLD;
    }

    getKitchenType(unit){
        const self = this;

        if(!unit){
            return '--';
        }
        let kitchen_type = self.SSConfigService.getUnitKitchenTypeName(unit.kitchen_type);

        // dry_kitchen variable can have values 0, 1, 2 upto x
        // 0 -> no dry kitchen
        // value 1 or above -> number of kitchens
        if(unit.dry_kitchen){
            kitchen_type += ' - Dry Kitchen';
            if(unit.dry_kitchen > 1){
                kitchen_type += ' ' + unit.dry_kitchen;
            }
        }
        return kitchen_type;
    }

    getDate(unit){
        const self = this;

        try{
            let date = unit.updated_at ? unit.updated_at : unit.created_at;
            if(date){
                return self.SSUtilService.formatUtcToLocalDate(date) + " " + self.SSUtilService.formatUtcToLocalTime(date);
            }
            else{
                return '--';
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    applyChanges() {
        const self = this;

        self.SSAlertService.success('');
        self.param.unit_ids = [];

        let units = self.unitsBackup;

        self.agencyIdSelected =[];

        jQuery.each(self.selectedAgency, function (i, agency) {
            self.agencyIdSelected.push(agency.id);
        });

        jQuery.each(units, function (i, item) {

            if (self.checkboxes.items[item.id] == true) {
                self.param.unit_ids.push(item.id);
                self.edited_units.push(item.id);

                jQuery.each(units, function (i, unit) {

                    if(unit.id == item.id) {

                        if(self.param.update_price_by==="1"){
                            unit.price=self.param.price;
                        }else if(self.param.update_price_by==="2") {
                            if(self.param.price!=="undefined" && self.param.price !== null && self.param.price !== "") {

                                let x = parseFloat(Number((self.param.price / 100) * self.units_master_converted[i].price).toFixed(2));
                                let y = parseFloat(Number(self.units_master_converted[i].price).toFixed(2));
                                unit.price=x+y;
                            }
                            else {
                                unit.price = self.param.price;
                            }
                        }else if(self.param.update_price_by==="3") {
                            if(self.param.price!=="undefined" && self.param.price !== null && self.param.price !== "") {
                                console.log("price"+self.param.price);
                                let x = parseFloat(Number((self.param.price / 100) * self.units_master_converted[i].price).toFixed(2));
                                let y = parseFloat(Number(self.units_master_converted[i].price).toFixed(2));
                                unit.price=y-x;
                            }
                            else {
                                unit.price=self.param.price;
                            }
                        }else if(self.param.update_price_by==="4") {
                            if(self.param.price!=="undefined" && self.param.price !== null && self.param.price !== "") {
                                let y = parseFloat(Number(self.units_master_converted[i].price).toFixed(2));
                                unit.price=self.param.price+y;
                            }
                        } else if(self.param.update_price_by==="5") {
                            if(self.param.price!=="undefined" && self.param.price !== null && self.param.price !== "") {
                                let y = parseFloat(Number(self.units_master_converted[i].price).toFixed(2));
                                unit.price=y-self.param.price;
                            }
                        }

                        if(self.selectedAgency.length > 0) {

                            unit.agencyId = self.agencyIdSelected.join();
                            unit.commission = self.param.commission;
                            unit.incentives = self.param.broker_incentives_add;
                            unit.commission_gst = self.param.commission_gst
                            unit.gst_inclusive = self.param.gst_inclusive;
                        }

                        if(self.param.category) {
                            unit.category = self.param.category;
                            $('#unit_category_' + unit.id).addClass('highlight');
                        }

                        if(self.param.type) {
                            unit.type = self.param.type;
                            unit.floor_plan_id = self.param.type;
                            $('#unit_floorplan_' + unit.id).addClass('highlight');
                        }
                        if(self.param.name) {
                            unit.name = self.param.name;
                            $('#unit_name_' + unit.id).addClass('highlight');
                        }
                        if(self.param.pricetype) {
                            unit.pricetype = self.param.pricetype;
                            $('#unit_pricetype_' + unit.id).addClass('highlight');
                        }
                        if(self.editby && self.editby['Reserve Price']) { // reserve price selected in edit by dropdown
                            unit.reserve_price = (self.param.reserve_price || self.param.reserve_price === 0)? self.param.reserve_price : null;
                            $('#unit_reserve_price_' + unit.id).addClass('highlight');
                        }
                        if(self.param.price) {
                            $('#unit_price_' + unit.id).addClass('highlight');
                        }
                        if(self.param.status) {
                            unit.status = self.param.status;
                        }
                    }
                    self.formatUnitData(unit);

                });
                jQuery.each(self.param, function (i, field) {
                    let dirty_id = i + '_' + item.id;
                    if (jQuery.inArray(dirty_id, self.edited_fields) === -1) {
                        // self.edited_fields.push(dirty_id);
                    }
                });
            }
        });

        if (self.param.unit_ids.length == 0) {
            self.SSAlertService.danger('Please select unit(s) to apply changes.');
            return;
        } else if (!self.param.name
            && !self.param.price
            && !self.param.status
            && !self.param.category
            && !self.param.type
            && !self.selectedAgency.length > 0
            && !(self.editby && self.editby['Reserve Price']) // reserve price not selected in edit by dropdown
        ) {

            if(!self.edited_fields.length > 0)
            {
                self.SSAlertService.danger('Please provide correct value for at least one attribute (Price, Status, Name, Category, Type) to update unit(s).');
                return;
            } else {
                self.SSAlertService.success("Changes applied, Please click save");
            }

        } else {
            self.SSAlertService.success("Changes applied, Please click save");
        }

        if(self.selectedAgency.length > 0){

            // if(!self.param.commission || !self.param.broker_incentives_add){
            //     self.SSAlertService.danger('Please provide commission and incentives for selected agency.');
            //     return;
            // }
            // if(!self.param.commission_gst || !self.param.gst_inclusive){
            //     self.SSAlertService.danger('Please select GST for commission and incentives.');
            //     return;
            // }

            // if(!self.param.commission || !self.param.broker_incentives_add){
            //     self.SSAlertService.danger('Please provide commission and incentives for selected agency.');
            // }
            //
            // if(!self.param.commission_gst || !self.param.gst_inclusive){
            //     self.SSAlertService.danger('Please select GST for commission and incentives.');
            // }

            // if(!self.param.commission && !self.param.broker_incentives_add){
            //     self.SSAlertService.danger('Please provide commission or incentives for selected agency.');
            // }
            //
            // if(self.param.commission  && !self.param.commission_gst){
            //     self.SSAlertService.danger('Please select GST for commission.');
            // }
            //
            // if(self.param.broker_incentives_add  && !self.param.gst_inclusive){
            //     self.SSAlertService.danger('Please select GST for incentives.');
            // }
            if(self.param.agency_commission_value !== undefined && self.param.agency_commission_value !== null )
            {
                if(!self.param.agency_commission_type)
                {
                    self.SSAlertService.warning('Missing Params!', 'Please select agency commission type.');
                    return;
                }
            }

            if(self.param.agency_commission_type || self.param.agency_commission_gst_inclusive)
            {
                if(self.param.agency_commission_value === null || self.param.agency_commission_value === undefined)
                {
                    self.SSAlertService.warning('Missing Params!', 'Please enter agency commission.');
                    return;
                }
            }

            if(self.param.broker_incentives_value !== undefined && self.param.broker_incentives_value !== null)
            {
                if(!self.param.broker_incentives_type)
                {
                    self.SSAlertService.warning('Missing Params!', 'Please select agent incentive type.');
                    return;
                }
            }

            if(self.param.broker_incentives_type || self.param.broker_incentives_gst_inclusive)
            {
                if(self.param.broker_incentives_value === null || self.param.broker_incentives_value=== undefined )
                {
                    self.SSAlertService.warning('Missing Params!', 'Please enter agent incentive.');
                    return;
                }
            }
        }

        self.changesApplied = true;

        if (self.param.name
            || self.param.price
            || self.param.status
            || self.param.category
            || self.param.type
            || self.selectedAgency.length > 0
            || (self.editby && self.editby['Reserve Price']) // reserve price selected in edit by dropdown
        ) {
            self.units_master = angular.copy(units);
        }
    }

    selectedAlert() {
        const self = this;

        if (self.checkboxes.checked == true) {
            self.edited_status = "Changes will be applied to " + self.units.length + " rows";
        }else if(self.checkboxes.checked == false){
            self.edited_status = '';
        }
    }

    exportUnits(id){
        const self = this;

        let url = "sec/developer/properties/" + id + "/export";
        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href  = url;
    }
    exportUnitsAnnexAB(id){
        const self = this;

        let url = "sec/developer/properties/" + id + "/export-annex-a-b";
        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href  = url;
    }

    /**
     * Select or clear every (filtered) unit row to match the Select All state.
     *
     * Must be wired in the view via ng-model="ctrl.checkAll" + ng-change — never ng-click:
     * on checkboxes ng-click fires before ngModel writes the new state, so self.checkAll
     * would still hold the previous value and the toggle behaves inverted (WEB-3556).
     * Also called programmatically after self.checkAll is set explicitly
     * (cancelChanges, status-filter re-apply).
     *
     * @returns {void}
     */
    toggleCheckAll(){
        const self = this;

        self.checked = 0;
        // Uncheck all to apply new changes
        jQuery.each(self.unitsBackup, function (index, unit) {
            self.checkboxes.items[unit.id] = false;
        });

        self.edited_status = "";

        let units = self.unitsBackup;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        if(self.isStatusFilterApplied()){
            units = self.getUnitsByStatus(self.unit_status);
        }

        if(self.checkAll){
            // All units checked
            jQuery.each(units, function (index, unit) {
                self.checkboxes.items[unit.id] = true;
                self.checked += 1;
            });
            self.edited_status = "Changes will be applied to " + self.checked + " rows";
        }
        self.checkboxes.count = self.checked;
    }

    checkedAlert(unit) {
        const self = this;

        if(!self.checked)
        {
            self.checked = 0;
        }
        if(self.checkboxes.items[unit.id] == false){
            self.checkboxes.items[unit.id] == true;
            self.checked -= 1;
        }
        else if(self.checkboxes.items[unit.id] == true){
            self.checkboxes.items[unit.id] == false;
            self.checked += 1;
        }

        self.checkboxes.count = self.checked;
        self.edited_status = "Changes will be applied to " + self.checked + " rows";
    }

    addCommissionIncentives() {
        jQuery('#add_incentives').modal('show');
    }

    confirmApply() {
        const self = this;

        jQuery('#confirm_modal').modal('hide');

        self.OTPService.getVerified(function (data) {
            self._confirmApply(data);
        }, self.OTPService.TYPE_SESSION_2FA);
    }

    _confirmApply() {
        const self = this;

        let url = 'sec/developer/units/bulk-update';

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.param).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let updatedUnits = response.data.units;

            jQuery.each(updatedUnits, function (i, updatedUnit) {
                let oldUnit = self.SSUtilService.findValueFromArray(self.units, 'id', updatedUnit.id);
                angular.merge(oldUnit, updatedUnit);
                self.formatUnitData(oldUnit);
            });

            // self.tableParams.reload();
            self.checkboxes = {
                checked: false,
                count: 0,
                items: {}
            };

            self.SSAlertService.success('Data has been updated successfully.');
        });
    }

    // Units Import
    importUnits() {
        const self = this;

        if (!self.importParams.unitsExcelFile) {
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.uploadUnitsExcel(self.importParams.unitsExcelFile);
            }
        );
    }

    importUnitsAnnexAandB() {
        const self = this;

        if (!self.importParams.unitsAnnexAandBExcelFile) {
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.uploadUnitsAnnexAandBExcel(self.importParams.unitsAnnexAandBExcelFile);
            }
        );
    }

    uploadUnitsExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/units/parse'),
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);
            self.progressUploadingFiles = false;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!response.data.units) {
                self.SSAlertService.danger('Error!', 'Invalid or empty file.');
                return;
            }

            self.importData = response.data;

            if (self.importParams.unitsAssetFiles && self.importParams.unitsAssetFiles.length) {
                self.uploadUnitFiles(self.importParams.unitsAssetFiles);
            } else {
                self._importUnits();
            }

        }, function (response) {

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);

        }, function (evt) {
        });
    }

    uploadUnitsAnnexAandBExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/units/annex-a-b/parse'),
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);
            self.progressUploadingFiles = false;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!response.data.units_annex_a_b) {
                self.SSAlertService.danger('Error!', 'Invalid or empty file.');
                return;
            }

            self.importData = response.data;

            if (self.importParams.unitsAnnexAssetFiles && self.importParams.unitsAnnexAssetFiles.length) {
                self.uploadUnitAnnexFiles(self.importParams.unitsAnnexAssetFiles);
            } else {
                self._importUnitsAnnexAandB();
            }

        }, function (response) {

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);

        }, function (evt) {
        });
    }

    uploadUnitFiles(files) {
        const self = this;

        if (!files) return;

        let policyUrl = 'sec/developer/import/properties/s3-policy-document';
        let processedFiles = 0;

        self.assets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            jQuery.each(files, function (i, file) {
                self.SSAwsService.upload(file, policy, function (response) {

                    if (response instanceof Error) {
                        if (response.code == 401) {
                            self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                        } else if (response.code == 412) {
                            self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                        } else {
                            self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                        }
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Assets uploaded successfully.');

                    self.assets[response.config.data.file.name] = response.config.data.key;
                    processedFiles += 1;

                    self.filesUploadProgress = parseInt(100.0 * processedFiles / files.length);

                    if (processedFiles == files.length) {
                        self._importUnits();
                    }
                });
            });
        });
    }

    uploadUnitAnnexFiles(files) {
        const self = this;

        if (!files) return;

        let policyUrl = 'sec/developer/import/properties/s3-policy-document';
        let processedFiles = 0;

        self.assets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            jQuery.each(files, function (i, file) {
                self.SSAwsService.upload(file, policy, function (response) {

                    if (response instanceof Error) {
                        if (response.code == 401) {
                            self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                        } else if (response.code == 412) {
                            self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                        } else {
                            self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                        }
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Assets uploaded successfully.');

                    self.assets[response.config.data.file.name] = response.config.data.key;
                    processedFiles += 1;

                    self.filesUploadProgress = parseInt(100.0 * processedFiles / files.length);

                    if (processedFiles == files.length) {
                        self._importUnitsAnnexAandB();
                    }
                });
            });
        });
    }

    _importUnits() {
        const self = this;

        let importUrl = 'sec/developer/import/units';

        let params = {
            property_id: self.property.id,
            units: self.importData.units,
            assets: self.assets
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                // WEB-4600: show the API's reason (e.g. WEB-4599's 412029 list of bad rows:
                // row No., unit, column, value, accepted values) instead of a fixed
                // "Something went wrong" / "Please fill-in the valid information". 401
                // keeps the session-expiry handling via parseAndDisplayError().
                self.progressUploadingFiles = false;
                self.SSAlertService.parseAndDisplayServerError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');

            self.progressUploadingFiles = false;

            // Display errors as warnings
            let errors = "";
            jQuery.each(response.data.errors, function (i, error) {
                errors += "\n" + error;
            });
            if(errors.length > 0){
                self.SSAlertService.warning("Warning!", errors);
            }

            // Update local data
            jQuery.each(response.data.units, function (i, unit) {
                self.formatUnitData(unit);

                let oldUnit = self.SSUtilService.findValueFromArray(self.units, 'id', unit.id)
                if (oldUnit) {
                    angular.merge(oldUnit, unit);
                } else {
                    self.units.push(unit);
                }
            });

            self.showImport = false;
            // self.tableParams.reload();
            self.checkboxes = {
                checked: false,
                count: 0,
                items: {}
            };
        });
    }

    _importUnitsAnnexAandB() {
        const self = this;

        let importUrl = 'sec/developer/import/units/annex-a-b';

        let params = {
            property_id: self.property.id,
            units_annex_a_b: self.importData.units_annex_a_b,
            assets: self.assets
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 412) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                } else {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');

            self.progressUploadingFiles = false;

            // Display errors as warnings
            let errors = "";
            jQuery.each(response.data.errors, function (i, error) {
                errors += "\n" + error;
            });
            if(errors.length > 0){
                self.SSAlertService.warning("Warning!", errors);
            }

            // // Update local data
            // jQuery.each(response.data.units, function (i, unit) {
            //     self.formatUnitData(unit);
            //
            //     let oldUnit = self.SSUtilService.findValueFromArray(self.units, 'id', unit.id)
            //     if (oldUnit) {
            //         angular.merge(oldUnit, unit);
            //     } else {
            //         self.units.push(unit);
            //     }
            // });

            self.showImportAnnex = false;
            self.hidden = false;
            // self.tableParams.reload();
            // self.checkboxes = {
            //     checked: false,
            //     count: 0,
            //     items: {}
            // };
        });
    }

    // Units Import
    deleteUnit(unit_id){
        const self = this;

        if (!self.property.id) {
            return;
        }
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this unit?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/properties/' + self.property.id + '/' + unit_id + '/delete';
                loading(true);
                self.SSHttpService.postAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.danger('Error! :', response.message);
                        return;
                    }
                    else{
                        self.getUnits();
                        self.SSAlertService.success('Success! :', response.message);
                    }
                });
            }
        );
    }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: '5 Rows'
            },
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }
    }

    goToAddCommission(unit){
        const self = this;

        self.$window.location = '/developer/properties/' + self.property.named_id + '/units/' + unit.id + '/commission-incentives';
    }

    goToUnitDetail(unit){
        const self = this;

        self.$window.location = '/developer/properties/' + self.property.named_id + '/units/' + unit.id + '/details';
    }

    gotoAssetsPage(unit){
        const self = this;

        let url = '/developer/properties/' + self.property.named_id + '/units/' + unit.id + '/assets';

        self.$window.location = url;
    }

    resetSearchFilter() {
        const self = this;

        self.block_no_search = "";
        self.unit_no_search = "";
        self.category_search = "";
        self.floor_plan_type_search = "";
        self.name_search = "";
        self.price_type_search = "";
        self.reserve_price_search = "";
        self.price_search = "";
        self.psf_search = "";
        self.status_search = "";
    }
    getGSTSettings() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/settings/unit_price_gst_inclusive';

        self.SettingsService.getPropertySetting(url, 'unit_price_gst_inclusive', function (response) {
            if(response && response.unit_price_gst_inclusive && response.unit_price_gst_inclusive.value){
                self.unit_price_gst_inclusive = response.unit_price_gst_inclusive.value;
                self.old_unit_price_gst_inclusive = JSON.parse(JSON.stringify(response.unit_price_gst_inclusive.value));
            }

            if (!self.unit_price_gst_inclusive) {
                self.unit_price_gst_inclusive = {enable:null};
                self.old_unit_price_gst_inclusive = {enable:null};// Init with null
            }
        });
    }

    saveSelectionSetting() {
        const self = this;
        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {
                self.updateGSTSettings();
            }
        );
    }


    updateGSTSettings() {
        const self = this;
        let url = 'sec/developer/properties/' + self.property.id + '/settings';
        loading(true);
        let params = {
            name : 'unit_price_gst_inclusive',
            value : JSON.stringify(self.unit_price_gst_inclusive)
        }
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
            }
            if(response && response.data && response.data.property_setting){
                self.isGSTSettingEnable = false;
                self.old_unit_price_gst_inclusive = JSON.parse(JSON.stringify(self.unit_price_gst_inclusive));
                self.SSAlertService.success('Success! :', 'GST setting updated successfully.');
            }
        });
    }

    cancelGSTSettingEnable(){
        const self = this;
        self.isGSTSettingEnable = false;
        self.unit_price_gst_inclusive = JSON.parse(JSON.stringify(self.old_unit_price_gst_inclusive));
    }

}

UnitIndexController.$inject = ['$scope', '$window', '$filter', 'Upload', 'SSHttpService', 'SSConfigService', 'SSAlertService', 'SSUtilService', 'OTPService', 'SSAppService', 'NgTableParams', 'SSAwsService', 'SSUserService','SSAnalyticsService','SSConfirmationService','SettingsService'];
app.controller('UnitIndexController', UnitIndexController);